export default {
    getException(obj1, exceptions) {
        let sortExceptions = exceptions.sort((a, b) => a.x1 - b.x1)
        for (let obj2 of sortExceptions) {
            if (obj1.x1 >= obj2.x1 && obj1.x1 <= obj2.x2 ||
                obj1.x2 > obj2.x1 && obj1.x2 <= obj2.x2 ||
                ((obj1.x1 <= obj2.x1) && (obj2.x2 <= obj1.x2))) {
                return obj2
            }
        }
        return null
    },
    ucFirst(str) {
        if (!str) return str;
        return str;
    },
    checkDisabled(item, goodsList) {
        for (let ex of item.exception_item_list) {
            for (let good of goodsList) {
                if (ex == good.id) {
                    return true
                }
            }
        }
        for (let good of goodsList) {
            for (let ex of good.exception_item_list) {
                if (ex == item.id) {
                    return true
                }
            }
        }
        return false
    }
}
